console.log("Sell form JS loaded");

(function () {
  emailjs.init("lnxh0GRDoXmbpmJxU"); // replace
})();

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("sellWatchForm");
  if (!form) return;

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const files = document.getElementById("photos").files;
    let fileNames = [];

    for (let i = 0; i < files.length && i < 3; i++) {
      fileNames.push(files[i].name);
    }

    emailjs.send("service_tteo4ja", "template_i7akd0c", {
      brand: form.brand.value,
      model: form.model.value,
      name: form.name.value,
      email: form.email.value,
      phone: form.phone.value,
      city: form.city.value,
      photos: fileNames.join(", ")
    }).then(() => {
      alert("Quote request sent successfully!");
      form.reset();
    }).catch(() => {
      alert("Failed to send. Please try again.");
    });
  });
});
